export const version = { shortSHA: '554f99cc' };
